import styled from 'styled-components'
import * as All from '../BaseStyles'

export const AppContainerDiv = styled(All.Div)`
    margin: 0rem auto;
    padding: 0rem 2rem;
    width: 140rem;
    height: 100%;
`

export const AppScrollContainerDiv = styled(All.Div)`
    height: auto;
    max-height: calc(100vh - 10rem);
    overflow: auto;
`

export const EmptyAppListContainerDiv = styled(All.Div)`
    width: 100%;
    height: 100%;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
`

export const EmptyAppPhrase = styled.h2`
    margin: 0;
    padding: 0;
    font-size: 3rem;
    color: #DCDCDC;
    font-weight: 200;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`